/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { SybilCheck } from "../SybilCheck";

export class SybilCheck__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<SybilCheck> {
    return super.deploy(overrides || {}) as Promise<SybilCheck>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): SybilCheck {
    return super.attach(address) as SybilCheck;
  }
  connect(signer: Signer): SybilCheck__factory {
    return super.connect(signer) as SybilCheck__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SybilCheck {
    return new Contract(address, _abi, signerOrProvider) as SybilCheck;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "checkName",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "value",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "metadata",
        type: "uint256",
      },
    ],
    name: "CheckCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "checkName",
        type: "bytes32",
      },
    ],
    name: "CheckDeregistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "checkName",
        type: "bytes32",
      },
    ],
    name: "CheckRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "checkName",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "oldWeight",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newWeight",
        type: "uint256",
      },
    ],
    name: "CheckWeightChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "checkName",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "value",
        type: "bytes32",
      },
    ],
    name: "checkValueExists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "checkWeights",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "computeUserScore",
    outputs: [
      {
        internalType: "uint256",
        name: "score",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "checkName",
        type: "bytes32",
      },
    ],
    name: "didCompleteCheck",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "checkName",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "value",
        type: "bytes32",
      },
    ],
    name: "getCheckResult",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "checkName",
        type: "bytes32",
      },
    ],
    name: "getCheckValue",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "done",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "metadata",
            type: "uint256",
          },
        ],
        internalType: "struct SybilCheck.CheckValue",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initializeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "listChecks",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "checks",
        type: "bytes32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "checkName",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "weight",
        type: "uint256",
      },
    ],
    name: "registerCheck",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "checkName",
        type: "bytes32",
      },
    ],
    name: "removeCheck",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "checkName",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "value",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "metadata",
        type: "uint256",
      },
    ],
    name: "setCheckCompleted",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "checkName",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "weight",
        type: "uint256",
      },
    ],
    name: "updateCheckWeight",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
